/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';

export const ThemeCardRoot = styled.div<{ selected?: boolean }>`
	background: ${(p) => p.theme.card.background};
	border: 1px solid ${(p) => p.theme.card.default.border};
	border-radius: 6px;
	padding: 16px;
	cursor: pointer;
	transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;

	${(p) =>
		p.selected &&
		`
		border-color: ${p.theme.card.selected.border};
		box-shadow: ${p.theme.card.selected.boxShadow};
	`}

	&:hover {
		background-color: ${(p) => p.theme.surface[4]};
	}

	&:focus {
		outline: 2px solid ${(p) => p.theme.card.selected.border};
		outline-offset: 2px;
	}
`;

export const ThemeCardHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 12px;
`;

export const ThemeCardLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const RadioButton = styled.div<{ selected?: boolean }>`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	position: relative;
	flex: 0 0 24px;

	border: 2px solid ${(p) => (p.selected ? p.theme.form.radio.checked.border : p.theme.form.radio.default.border)};
	background: ${(p) => p.theme.form.radio.default.background};

	${(p) =>
		p.selected &&
		`

		&::after {
			content: '';
			position: absolute;
			left: 50%;
			top: 50%;
			width: 10px;
			height: 10px;
			transform: translate(-50%, -50%);
			border-radius: 10px;
			background: ${p.theme.form.radio.checked.border};
		}
	`}
`;

export const ThemeName = styled.div`
	font-size: 16px;
	font-weight: 500;
	color: ${(p) => p.theme.card.title};
`;

export const ThemeLabel = styled.div<{ isDefault?: boolean }>`
	font-size: 12px;
	color: ${(p) => (p.isDefault ? p.theme.card.subtitle : p.theme.text.disabled)};
	font-weight: ${(p) => (p.isDefault ? '400' : '500')};
	cursor: ${(p) => (p.isDefault ? 'default' : 'not-allowed')};
`;

export const ThemeLinkLabel = styled.a`
	font-size: 12px;
	color: ${(p) => p.theme.text.brand};
	font-weight: 500;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}
`;

export const ThemePreview = styled.div<{
	backgroundColor: string;
	backgroundImage?: string | null;
	backgroundSize?: string | null;
}>`
	background-color: ${(p) => p.backgroundColor};
	${(p) =>
		p.backgroundImage
			? `
		background-image: url(${p.backgroundImage});
		background-size: ${p.backgroundSize || 'cover'};
		background-position: center;
		background-repeat: no-repeat;
	`
			: ''}
	border-radius: 8px;
	padding: 16px;
	display: flex;
	gap: 16px;
	min-height: 120px;
`;

export const WidgetPreview = styled.div<{ widgetBackgroundColor: string; textColor: string }>`
	background: ${(p) => p.widgetBackgroundColor};
	border-radius: 8px;
	padding: 20px;
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: ${(p) => p.textColor};
`;

export const NumberValue = styled.div<{ color: string }>`
	font-size: 32px;
	font-weight: 600;
	color: ${(p) => p.color};
`;

export const ChartPreview = styled.div<{ widgetBackgroundColor: string }>`
	background: ${(p) => p.widgetBackgroundColor};
	border-radius: 8px;
	padding: 20px;
	flex: 2;
	position: relative;
	overflow: hidden;

	display: flex;
	align-items: center;
	gap: 10px;
`;

export const MiniChart = styled.svg`
	width: 100%;
	height: 100%;
`;
